import type {PromoNewRewardInterface} from 'app/interfaces/articles/PromoNewItemInterface';
import {fixed2int} from 'app/utils/fixed';

const parseRewardAmount = (amount: PromoNewRewardInterface['amount'] | number | null | undefined): number | null => {
    if (!amount && amount !== 0) {
        return null;
    }

    const normalized = String(amount).trim();

    if (normalized === '') {
        return null;
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed)
        ? parsed
        : null;
};

export const getPromoNewRewardDisplay = (
    reward?: PromoNewRewardInterface | null
): string | null => {
    const amount = parseRewardAmount(reward?.amount);

    if (amount === null) {
        return null;
    }

    return `$${fixed2int(amount)}`;
};
